import _styled from "@emotion/styled/base";

/**
 * External dependencies
 */

/**
 * `View` is a core component that renders everything in the library.
 * It is the principle component in the entire library.
 *
 * @example
 * ```jsx
 * import { View } from `@wordpress/components`;
 *
 * function Example() {
 * 	return (
 * 		<View>
 * 			 Code is Poetry
 * 		</View>
 * 	);
 * }
 * ```
 *
 * @type {import('../ui/context').WordPressComponent<'div', { children?: import('react').ReactNode }, true>}
 */
// @ts-ignore
const View = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "em57xhy0"
} : {
  target: "em57xhy0",
  label: "View"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkB3b3JkcHJlc3MvY29tcG9uZW50cy9zcmMvdmlldy9jb21wb25lbnQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBeUJ1QiIsImZpbGUiOiJAd29yZHByZXNzL2NvbXBvbmVudHMvc3JjL3ZpZXcvY29tcG9uZW50LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBFeHRlcm5hbCBkZXBlbmRlbmNpZXNcbiAqL1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG4vKipcbiAqIGBWaWV3YCBpcyBhIGNvcmUgY29tcG9uZW50IHRoYXQgcmVuZGVycyBldmVyeXRoaW5nIGluIHRoZSBsaWJyYXJ5LlxuICogSXQgaXMgdGhlIHByaW5jaXBsZSBjb21wb25lbnQgaW4gdGhlIGVudGlyZSBsaWJyYXJ5LlxuICpcbiAqIEBleGFtcGxlXG4gKiBgYGBqc3hcbiAqIGltcG9ydCB7IFZpZXcgfSBmcm9tIGBAd29yZHByZXNzL2NvbXBvbmVudHNgO1xuICpcbiAqIGZ1bmN0aW9uIEV4YW1wbGUoKSB7XG4gKiBcdHJldHVybiAoXG4gKiBcdFx0PFZpZXc+XG4gKiBcdFx0XHQgQ29kZSBpcyBQb2V0cnlcbiAqIFx0XHQ8L1ZpZXc+XG4gKiBcdCk7XG4gKiB9XG4gKiBgYGBcbiAqXG4gKiBAdHlwZSB7aW1wb3J0KCcuLi91aS9jb250ZXh0JykuV29yZFByZXNzQ29tcG9uZW50PCdkaXYnLCB7IGNoaWxkcmVuPzogaW1wb3J0KCdyZWFjdCcpLlJlYWN0Tm9kZSB9LCB0cnVlPn1cbiAqL1xuLy8gQHRzLWlnbm9yZVxuY29uc3QgVmlldyA9IHN0eWxlZC5kaXZgYDtcblZpZXcuc2VsZWN0b3IgPSAnLmNvbXBvbmVudHMtdmlldyc7XG5WaWV3LmRpc3BsYXlOYW1lID0gJ1ZpZXcnO1xuXG5leHBvcnQgZGVmYXVsdCBWaWV3O1xuIl19 */");

View.selector = '.components-view';
View.displayName = 'View';
export default View;
//# sourceMappingURL=component.js.map